import React from 'react';
import { styled } from '@teko/ds-desktop';
import { getTrackingData } from '@teko/tracking';
import { useRouter } from 'next/router';
import { ProductListItem } from '../ProductListItem/ProductListItem.es.js';
import { useDevice } from '../../contexts/DeviceContext.es.js';
import { hasComboDiscount } from '../../helpers/combo.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductList = ({
  products,
  regionName,
  contactLink,
  className,
  hideCtaButton,
  itemsPerPage
}) => {
  const { isMobile } = useDevice();
  const ItemWrapper = isMobile ? ItemWrapperMobile : ItemWrapperDesktop;
  const router = useRouter();
  const page = router.query.page ? Number(router.query.page) : 1;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Wrapper, {
    className
  }, products == null ? void 0 : products.map((_a, index) => {
    var _b = _a, { onWrapperAuxClick, onWrapperClick } = _b, restItem = __objRest(_b, ["onWrapperAuxClick", "onWrapperClick"]);
    return /* @__PURE__ */ React.createElement(ItemWrapper, {
      key: index,
      onAuxClick: onWrapperAuxClick,
      onClick: onWrapperClick
    }, /* @__PURE__ */ React.createElement(ProductListItem, __spreadProps(__spreadValues({}, restItem), {
      tracking: regionName ? getTrackingData({
        isTrackContent: true,
        regionName,
        contentName: restItem.sku,
        target: "productDetail",
        index: itemsPerPage ? index + (page - 1) * itemsPerPage : index,
        payload: hasComboDiscount(restItem.bestComboDiscount) ? JSON.stringify({ promotionType: "combo" }) : void 0
      }) : {},
      ctaTracking: regionName && contactLink ? getTrackingData({
        isTrackContent: true,
        regionName,
        contentName: "contactSale",
        target: contactLink,
        payload: JSON.stringify({ sku: restItem.sku })
      }) : {},
      addToCart: hideCtaButton ? void 0 : restItem.addToCart
    })));
  })));
};
const Wrapper = styled.div`
  width: 100%;
`;
const ItemWrapperDesktop = styled.div`
  &:not(:last-child) {
    border-bottom: 1px solid #e4e5f0;
  }
`;
const ItemWrapperMobile = styled.div`
  &:not(:last-child) {
    margin-bottom: 4px;
  }
`;

export { ProductList };
